import type { FormInstance } from 'antd';
import { isDedicatedFontFamilyBase } from '../../utils/fontFamily';
import { styleFieldName } from '../../utils/styleFormFieldNames';

/** Dedicated bundled fonts use font files for weight/style — clear CSS fontWeight. */
export function applyDedicatedTypographyToForm(
  form: FormInstance,
  namePrefix: string | string[] | undefined,
): boolean {
  const fontFamily = form.getFieldValue(styleFieldName(namePrefix, 'fontFamily'));
  if (!isDedicatedFontFamilyBase(fontFamily)) return false;
  form.setFieldValue(styleFieldName(namePrefix, 'fontWeight'), undefined);
  return true;
}
